<template>
  <el-row class="editPanel">
    <h3 :class="{closed: !panelOpen}">History</h3><span class="toggle" @click="panelOpen = panelOpen !== true" :class="{closed: !panelOpen}"></span>
    <transition name="panel">
      <el-col :span="24" class="pea-panel" v-if="panelOpen" ref="peaPanel">
        <el-table
         :data="tableData"
         stripe
         v-loading="tableLoading"
         >
         <el-table-column align="left"
           prop="userFullName"
           label="Update By">
         </el-table-column>
         <el-table-column align="left"
           prop="status"
           label="Event">
         </el-table-column>
         <el-table-column class-name="wrap" style="word-wrap:break-word" align="left"
           prop="statusDate"
           label="Date">
           <template slot-scope="props">
            {{ getStatusDate(props.row) }}
           </template>
         </el-table-column>
         <el-table-column class-name="wrap" style="word-wrap:break-word" align="left"
           prop="approvalComment"
           label="Comments">
         </el-table-column>
        </el-table>
        <br/>
        <el-pagination v-if="resultTotal > pageSize"
          @current-change="fetchData"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="resultTotal">
        </el-pagination>
        <br/>
      </el-col>
    </transition>
  </el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'pea-status-history',
  props: {
    peaId: {
      default: 0
    }
  },
  data () {
    return {
      tableData: [{}],
      currentPage: 1,
      pageSize: 5,
      resultTotal: 0,
      panelOpen: true,
      tableLoading: true
    }
  },
  methods: {
    fetchData: function () {
      this.tableLoading = true
      var call = '/getPEAStatusHistory/' + this.peaId + '?page=' + this.currentPage + '&pageSize=' + this.pageSize
      this.$axios.get(call).then(response => {
        this.tableData = response.data.results
        this.resultTotal = response.data.totalRecords
        this.tableLoading = false
        this.$emit('fetchComplete')
      }).catch(reject => {
        this.tableLoading = false
        this.tableData = null
        this.resultTotal = 0
      })
    },
    getStatusDate: function (entry) {
      return helperMethods.formatDate(entry.statusDate)
    },
    startUp () {
      // eslint-disable-next-line
      if (this.peaId != 0) {
        this.fetchData()
      } else {
        this.tableData = null
        this.getStatusDate({})
      }
    }
  },
  mounted () {
    this.startUp()
  },
  watch: {
    // watch for route change - going from pea/4 to pea/0
    '$route': 'startUp'
  }
}
</script>

<style scoped>

</style>
